(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/login-checks/login-check.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/login-checks/login-check.js');

'use strict';

svs.player_login.views.loginChecks.LoginCheck = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.login_check(data);
  },
  templateContext() {
    return {
      viewData: {
        pageTitle: this.getOption('pageTitle'),
        backLinkText: this.getOption('backLinkText'),
        backLinkUrl: this.getOption('backLinkUrl'),
        externalReturnUrl: this.getOption('externalReturnUrl')
      }
    };
  },
  regions: {
    containerRegion: '#containerRegion'
  },
  behaviors: {
    ServerSideRendering: {
      behaviorClass: svs.app.ServerSideHelper.ServerSideRendering,
      regionSetup() {
        if (this.getOption('useMarionette')) {
          const _this$getOption = this.getOption('component'),
            _this$getOption$init = _this$getOption.init,
            init = _this$getOption$init === void 0 ? () => undefined : _this$getOption$init;
          return {
            containerRegion: {
              view: init,
              options: this.getOption('component-options')
            }
          };
        }
        return {};
      }
    }
  },
  onAttach() {
    if (!this.getOption('useMarionette')) {
      const _this$getOption2 = this.getOption('component'),
        _this$getOption2$init = _this$getOption2.init,
        init = _this$getOption2$init === void 0 ? () => undefined : _this$getOption2$init;
      init(this.getRegion('containerRegion').el);
    }
  }
});

 })(window);